import React from "react";

//Styles
import "./Footer.scss";

//Data
import { footerExampleData } from "./exampleData";

//Components
import Button from "common-components/Button/Button";

//Asssets
import { ReactComponent as FooterLogoSvg } from "assets/footer-logo.svg";

function Footer() {
  const { menus, socials } = footerExampleData;
  return (
    <footer>
      <div className="links-and-signup l-width-wrapper">
        <ul className="links">
          {menus.map(({ link, text }, index) => (
            <li key={index}>
              <a href={link}>{text}</a>
            </li>
          ))}
        </ul>
        <div className="signup">
          <p>Sign up for secrets, news and specials:</p>
          <div className="field-button">
            <input type="email" placeholder="E-mail" />
            <Button styleType="primary rounded">Sign up</Button>
          </div>
          <div className="socials">
            {socials.map(({ type, link }, index) => (
              <a key={index} className={type} href={link}>
                {type}
              </a>
            ))}
          </div>
        </div>
      </div>
      <div className="the-very-footer l-width-wrapper">
        <a href="/" className="footer-logo">
          <FooterLogoSvg />
        </a>
        <span>© 2003 — {new Date().getFullYear()} DesignContest LLC</span>
      </div>
    </footer>
  );
}

export default Footer;
